{
    "TelephoneserverLabel": "Telefonserver:",
    "PartitionsLabel": "Partition(en):",
    "ScopeFiltering_SectionHeader": "Bereichsfilterung",
    "NAME": "ScopeFiltering",
    "ScopeGroupsLabel": "Themenbereich(e):",
    "AnyScopeGroupsLabel": "[Beliebige Themengruppe]"
}